import { render, staticRenderFns } from "./BlockCard.vue?vue&type=template&id=73b67b6e"
import script from "./BlockCard.vue?vue&type=script&lang=js"
export * from "./BlockCard.vue?vue&type=script&lang=js"
import style0 from "./BlockCard.vue?vue&type=style&index=0&id=73b67b6e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports